export default {"src":"/_next/static/media/MPW.9cd90e7f.svg","height":18,"width":18};